<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >

        <template slot="photo" slot-scope="data">
            <div v-if="data.item.photo">
                <b-button size="sm" v-if="!data.detailsShowing" @click.stop="data.toggleDetails" variant="primary">Ver foto</b-button>
                <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails">Cerrar</b-button>    
            </div>
            <div v-else>
                --No Tiene Foto--
            </div>
            
        </template>

        <template slot="row-details" slot-scope="{ item }">
            <div class="d-flex justify-content-center">
                <div class="w-50">
                    <b-carousel id="carousel1"
                        style="text-shadow: 1px 1px 2px #333;"
                        controls
                        indicators
                        background="#ababab"
                        :interval="4000"
                        img-width="350px"
                        img-height="200px"
                    >
                        <b-carousel-slide img-height="200" :key="item.id" :img-src="item.photo"
                        ></b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button v-if="!item.photo" size="sm" variant="primary" @click="uploadPhoto(item)"><i class="fa fa-file-image-o"></i></b-button>            
            <b-button size="sm" variant="primary" @click="updateRestrictedVisitor(item)"><i class="fa fa-pencil"></i></b-button>
            <b-button size="sm" variant="danger" @click="removeRestrictedVisitor(item)"><i class="fa fa-trash"></i></b-button>
        </template>
        
    </app-data-table>
</template>
<script>
import fields from './fields.js';
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: fields
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        updateRestrictedVisitor(data){
            this.$emit('update-restricted-visitor', data);
        },
        removeRestrictedVisitor(data){
            this.$emit('remove-restricted-visitor', data);
        },
        uploadPhoto(data){
            this.$emit('upload-photo', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    }
}
</script>